import { type PayinPaymentChannel } from '~/entities/payin';
import { PayinBank, PayinPaymentMethod } from '~/entities/payin';
import { validateCardNumber } from '~/shared/ui/CardInput';
import { validatePhoneNumber } from '~/shared/ui/PhoneInput';
import { type CreateOrderFormValues, type PaymentMethod } from '../model';
import { isAmountAllowedByPaymentChannel, isBankAllowedByPaymentChannel } from './findMatchingPaymentChannel';

export const validateForm = (
    values: CreateOrderFormValues,
    paymentChannels: PayinPaymentChannel[],
    paymentMethod: PaymentMethod,
) => {
    const errors: Record<string, string> = {};

    if (!values.amount.value) {
        errors['amount.value'] = 'Сумма обязательна к заполнению';
    }

    if (paymentMethod === PayinPaymentMethod.METHOD_SBP) {
        const phoneNumberError = validatePhoneNumber(values.requisite.sbp.phoneNumber, { required: true });

        if (phoneNumberError) {
            errors['requisite.sbp.phoneNumber'] = phoneNumberError;
        }

        if (!values.requisite.sbp.bank || values.requisite.sbp.bank === PayinBank.BANK_UNSPECIFIED) {
            errors['requisite.sbp.bank'] = 'Банк обязателен к заполнению';
        }
    }

    if (paymentMethod === PayinPaymentMethod.METHOD_CARD) {
        const cardNumberError = validateCardNumber(values.requisite.card.number, { required: true });

        if (cardNumberError) {
            errors['requisite.card.number'] = cardNumberError;
        }
    }

    if (values.amount.value && !errors['amount.value']) {
        const methodChannels = paymentChannels.filter((channel) => {
            return channel.filter?.method === paymentMethod;
        });

        const amountMatchingChannels = methodChannels.filter((channel) => {
            return isAmountAllowedByPaymentChannel(channel, values.amount.value ?? 0);
        });

        if (amountMatchingChannels.length === 0) {
            errors['amount.value'] = 'Сумма не попадает в лимиты доступных платежных каналов';

            return errors;
        }

        if (
            paymentMethod === PayinPaymentMethod.METHOD_SBP &&
            values.requisite.sbp.bank &&
            values.requisite.sbp.bank !== PayinBank.BANK_UNSPECIFIED
        ) {
            const hasBankMatchingChannel = amountMatchingChannels.some((channel) => {
                return isBankAllowedByPaymentChannel(channel, values.requisite.sbp.bank);
            });

            if (!hasBankMatchingChannel) {
                errors['requisite.sbp.bank'] = 'Банк не подходит ни к одному платежному каналу';
            }
        }
    }

    return errors;
};
